export default __webpack_public_path__ + "static/media/donemark.b10238d1.svg";